// extracted by mini-css-extract-plugin
export default {"copyButton":"style_copyButton__Y4jJJ","privateKey":"style_privateKey__6FVmL"};